<div class="dropdown-wrapper">
    <button class="icon-btn" type="button" (click)="toggleNotifications()">
        <i-lucide name="bell" size="20" color="#4A5565"></i-lucide>
        <span class="notification-badge" *ngIf="naoLidasCount > 0">{{ naoLidasCount }}</span>
    </button>

    <div class="dropdown notifications" *ngIf="showNotifications">
        <div class="dropdown-header">
            <strong class="title">Notificações</strong>

            <div class="header-actions">
                <button class="link-btn" type="button" (click)="marcarTodasComoLidas()">
                    Marcar todas como lidas
                </button>

                <button class="link-btn" type="button" (click)="openHistory()">
                    Ver histórico
                </button>
                <button
                    class="close-btn"
                    type="button"
                    (click)="showNotifications = false"
                    aria-label="Fechar notificações">
                    <i-lucide name="x" size="18"></i-lucide>
                </button>
            </div>
        </div>

        <div class="notifications-list">
            <div class="notification-item" *ngFor="let notificacoes of notifications"
                (click)="abrirDetalhes(notificacoes)" [class.unread]="!notificacoes.lida">
                <span class="status-icon" [ngClass]="notificacoes.type">
                    <i-lucide *ngIf="notificacoes.type === 'success'" name="circle-check-big" size="18">
                    </i-lucide>

                    <i-lucide *ngIf="notificacoes.type === 'warning'" name="circle-alert" size="18">
                    </i-lucide>

                    <i-lucide *ngIf="notificacoes.type === 'danger'" name="circle-alert" size="18">
                    </i-lucide>

                    <i-lucide *ngIf="notificacoes.type === 'info'" name="circle-alert" size="18">
                    </i-lucide>
                </span>

                <div class="content">

                    <div class="line-1">
                        <strong class="item-title">{{ notificacoes.title }}</strong>
                        <span class="unread-dot" *ngIf="!notificacoes.lida" aria-hidden="true"></span>
                    </div>

                    <p class="item-subtitle">{{ notificacoes.subtitle }}</p>
                    <p class="item-text">{{ notificacoes.text }}</p>

                    <div class="meta">
                        <small class="time">{{ notificacoes.time }}</small>
                        <button class="action-btn" type="button"
                            (click)="$event.stopPropagation(); abrirDetalhes(notificacoes)">
                            Ver detalhes
                        </button>
                    </div>
                </div>

            </div>
        </div>

    </div>
</div>